import React, { useRef } from 'react';
import { PixelRatio, StyleSheet, Text, TouchableHighlight, View } from 'react-native';
import { useHover } from 'react-native-web-hooks';
import useFontSize from '../../shell/hooks/useFontSize';
import { isMobile } from '../../shell/utils/platformCheck';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectGameObject } from '../../store/slices/gameObjectSlice';
import { GameNames } from '../../store/slices/GameTypes';
import { selectMenu } from '../../store/slices/menuSlice';
import { store } from '../../store/store';
import { parseRequire } from '../../utils/parseImageUrl';
import { MenuButton } from './MenuButton';


export enum MenuOptions {
    INIT = "INIT",
    CONTINUE = "CONTINUE",
    NEW_GAME = "NEW GAME",
    SAVE = "SAVE",
    LOAD = "LOAD",
    SETTINGS = "SETTINGS",
    SCENES = "SCENES",
    CREDIT = "CREDIT",
    GALLERY = "GALLERY",
    EXIT = "EXIT"
}

interface TMainMenuProps {
    onclick: (item: MenuOptions) => void;

}


export const SideBar: React.FC<TMainMenuProps> = ({ onclick }) => {
    const menuSlice = useAppSelector(selectMenu);
    const { lastUpdated } = useAppSelector(selectGameObject).present;




    const styles = StyleSheet.create({
        container: {
            position: "absolute",
            width: "100%",
            height: "100%",
            marginTop: "2%",
            justifyContent: "space-around"


        },
        menuImage: {
            position: 'absolute',
            width: "100%",
            height: "100%",
        },

        button: {
            // backgroundColor: '#FFF',
            // borderRadius: 50 / PixelRatio.get(),
            // opacity: 0.8,
            // padding: useFontSize(1 / PixelRatio.get())

        },


        hover: {
            // color: "black",
        }
    });

    const onMenuPressed = (item: MenuOptions) => {
        onclick(item);

    };


    return (
        <View style={styles.container}>
            {lastUpdated !== GameNames.INIT ? <MenuButton text={MenuOptions.CONTINUE} touchable={{
                onPress: () => onMenuPressed(MenuOptions.CONTINUE),
            }}><Text>{MenuOptions.CONTINUE}</Text></MenuButton> : <></>}

            <MenuButton text={MenuOptions.NEW_GAME} touchable={{
                onPress: () => onMenuPressed(MenuOptions.NEW_GAME),
            }}><Text >{MenuOptions.NEW_GAME}</Text></MenuButton>

            <MenuButton text={MenuOptions.LOAD} touchable={{
                onPress: () => onMenuPressed(MenuOptions.LOAD),
            }}><Text >{MenuOptions.LOAD}</Text></MenuButton>

            {lastUpdated !== GameNames.INIT ? <MenuButton text={MenuOptions.SAVE} touchable={{
                onPress: () => onMenuPressed(MenuOptions.SAVE),
            }}><Text >{MenuOptions.SAVE}</Text></MenuButton> : <></>}

            <MenuButton text={MenuOptions.SETTINGS} touchable={{
                onPress: () => onMenuPressed(MenuOptions.SETTINGS),
            }}><Text >{MenuOptions.SETTINGS}</Text></MenuButton>
            {
                isMobile() ? <></> :
                    <>

                        <MenuButton text={MenuOptions.SCENES} touchable={{
                            onPress: () => onMenuPressed(MenuOptions.SCENES),
                        }}><Text >{MenuOptions.SCENES}</Text></MenuButton>
                        <MenuButton text={MenuOptions.GALLERY} touchable={{
                            onPress: () => onMenuPressed(MenuOptions.GALLERY),
                        }}><Text >{MenuOptions.GALLERY}</Text></MenuButton>
                    </>
            }
            {/* <MenuButton text={MenuOptions.CREDIT} touchable={{
                onPress: () => onMenuPressed(MenuOptions.CREDIT),
            }}><Text >{MenuOptions.CREDIT}</Text></MenuButton> */}

            <MenuButton text={MenuOptions.EXIT} touchable={{
                onPress: () => onMenuPressed(MenuOptions.EXIT),
            }}><Text >{MenuOptions.EXIT}</Text></MenuButton>








        </View>
    );
};